/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import { useGetContentfulQuery } from '../../redux/slices/content/apiContentSlice';
import moment from 'moment';
import { Contentful } from '../../redux/slices/content/contentModels';

const AuthLayout = () => {

  const contentCategory = 2; // dashboard
  const { data: allAuthSlides } = useGetContentfulQuery(contentCategory, {refetchOnMountOrArgChange: true});
  // console.log("allAuthSlides: ", allAuthSlides);

  const [runningAuthSlides, setRunningAuthSlides] = useState<Contentful[]>([])
  // console.log("runningAuthSlides: ", runningAuthSlides);

  useEffect(() => {  
    if (allAuthSlides){
      setRunningAuthSlides(allAuthSlides.filter((slide)=> {return moment().isBetween(moment(slide.startDate, "YYYY-MM-DD"), moment(slide.endDate, "YYYY-MM-DD"))}))
    } 
  }, [allAuthSlides])



  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  // -----------------------------------------------

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
      {/* begin::Body */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1 bg-gray-200'>
        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          {/* begin::Wrapper */}
          <div className='w-lg-500px p-10'>
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}

        {/* begin::Footer */}
        <div className='d-flex flex-center flex-wrap px-5'>
          <div className='d-flex fw-semibold text-primary fs-base'>
            <a href='https://superbolt.com.au' className='px-5'>
              Home
            </a>
            {/* <a href='/terms' className='px-5' target='_blank'>
              Terms
            </a>
            <a href='/plans' className='px-5' target='_blank'>
              Plans
            </a> */}            
            <a href='https://superbolt.com.au/contact/' className='px-5'>
              Contact Us
            </a>
          </div>
        </div>
        {/* end::Footer */}
      </div>
      {/* end::Body */}

      {/* begin::Aside */}
      <div
        className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2'
        style={{backgroundImage: `url(${toAbsoluteUrl('/media/misc/auth-screens-bg.jpg')})`}}
      >
        {/* begin::Content */}
        <div className='d-flex flex-column flex-center py-5 px-5 px-md-5 w-100'>
          {/* begin::Logo */}
          
          <div id="kt_carousel_1_carousel"
            className="carousel carousel-custom slide"
            data-bs-ride="carousel"              
            data-bs-interval="4000"
            data-bs-loop={true}
          >
            {!runningAuthSlides &&
              <div className="carousel-inner pt-8">
                <div className="carousel-item active">
                  <div className='d-flex flex-column flex-center'>
                    <a href='https://superbolt.com.au' className='px-5'>
                      <img alt='Logo' src={toAbsoluteUrl('/media/logos/custom-1-white.png')} 
                      className='mx-auto w-400px w-md-600px px-20 px-xxl-20  mb-10 mb-lg-20' 
                      />
                    </a>
                    <h1 className=' text-white mt-10 pt-10' style={{fontSize: "28px"}}> Create, schedule, publish.</h1>
                    <h1 className='text-white fs-2qx fw-bolder text-center mb-7 pb-6'>
                      <span style={{background: "linear-gradient(to right, #FFD80C 0%, #12CE5D 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent"}}>
                        <span id="kt_landing_hero_text">   Lightning Fast.</span>            
                      </span>          
                    </h1>                  
                    <img
                      className='mx-auto w-375px w-md-100 w-xl-500px w-xxl-100 px-0 px-xxl-20  mb-10 mb-lg-20'
                      src={toAbsoluteUrl('/media/misc/auth-screens-01.png')}
                      alt=''
                    />
                  </div>
                </div>
              </div>
            }
            {runningAuthSlides && 
              <div className="carousel-inner h-95 pt-8">
                {runningAuthSlides.map((slide, ind) => {
                  return <div key={`slide-${ind}`} className={`carousel-item ${ind === 0 ? "active":""}`} dangerouslySetInnerHTML={{ __html: slide.description}}/>
                  // return <div className={`carousel-item ${ind == 0 ? "active":""}`} dangerouslySetInnerHTML={{ __html: 
                    // `<div class='d-flex flex-column flex-center'>
                    //   <a href='https://superbolt.com.au' class='px-5'>
                    //     <img alt='Logo' src='./media/logos/custom-1-white.png' 
                    //     class='mx-auto w-400px w-md-600px px-20 px-xxl-20 mb-10 mb-lg-20' 
                    //     />
                    //   </a>                  
                    //   <h1 class='text-white fs-2qx fw-bolder text-center mb-7'>                    
                    //     <span id="kt_landing_hero_text">Boost Your Brand Awareness</span><br/>            
                    //     <span id="kt_landing_hero_text">Anywhere, Anytime!</span>
                    //   </h1>
                    //   <h1 class=' text-white  mb-7' style='fontSize: "56px"'>                    
                    //     <span style="background: linear-gradient(to right, #FFD80C 0%, #12CE5D 100%); background-clip: text; -webkit-text-fill-color: transparent;">
                    //       <span id="kt_landing_hero_text">30 Day Free Trial.</span>           
                    //     </span>
                    //   </h1>
                    //   <img
                    //     class='mx-auto w-375px w-md-100 w-xl-500px w-xxl-100 px-0 px-xxl-20  mb-10 mb-lg-20 rounded-2'
                    //     src='./media/misc/auth-screens-01.png'
                    //     alt=''
                    //   />
                    // </div>`
                  
                    // `<div class='d-flex flex-column flex-center'>
                    //   <a href='https://superbolt.com.au' class='px-5'>
                    //     <img alt='Logo' src='./media/logos/custom-1-white.png' 
                    //     class='mx-auto w-400px w-md-600px px-20 px-xxl-20  mb-10 mb-lg-20' 
                    //     />
                    //   </a>
                    //   <h1 class=' text-white mt-10 pt-10' style='fontSize: 28px'> Create, schedule, publish.</h1>
                    //   <h1 class='text-white fs-2qx fw-bolder text-center mb-7 pb-6'>
                    //     <span style="background: linear-gradient(to right, #FFD80C 0%, #12CE5D 100%); background-clip: text; -webkit-text-fill-color: transparent;">
                    //       <span id="kt_landing_hero_text">   Lightning Fast.</span>            
                    //     </span>          
                    //   </h1>                  
                    //   <img
                    //     class='mx-auto w-375px w-md-100 w-xl-500px w-xxl-100 px-0 px-xxl-20  mb-10 mb-lg-20'
                    //     src='./media/misc/auth-screens-01.png'
                    //     alt=''
                    //   />
                    // </div>`
                  // }}/>                  
                })}
              </div>
            }              
            {/* <div className="carousel-inner pt-8">
              <div className="carousel-item active">
                <div className='d-flex flex-column flex-center'>
                  <a href='https://superbolt.com.au' className='px-5'>
                    <img alt='Logo' src={toAbsoluteUrl('/media/logos/custom-1-white.png')} 
                    className='mx-auto w-400px w-md-600px px-20 px-xxl-20  mb-10 mb-lg-20' 
                    />
                  </a>
                  <h1 className=' text-white mt-10 pt-10' style={{fontSize: "28px"}}> Create, schedule, publish.</h1>
                  <h1 className='text-white fs-2qx fw-bolder text-center mb-7 pb-6'>
                    <span style={{background: "linear-gradient(to right, #FFD80C 0%, #12CE5D 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent"}}>
                      <span id="kt_landing_hero_text">   Lightning Fast.</span>            
                    </span>          
                  </h1>                  
                  <img
                    className='mx-auto w-375px w-md-100 w-xl-500px w-xxl-100 px-0 px-xxl-20  mb-10 mb-lg-20'
                    src={toAbsoluteUrl('/media/misc/auth-screens-01.png')}
                    alt=''
                  />
                </div>
              </div>

              <div className="carousel-item">
                <div className='d-flex flex-column flex-center'>
                  <a href='https://superbolt.com.au' className='px-5'>
                    <img alt='Logo' src={toAbsoluteUrl('/media/logos/custom-1-white.png')} 
                    className='mx-auto w-400px w-md-600px px-20 px-xxl-20  mb-10 mb-lg-20' 
                    />
                  </a>                  
                  <h1 className='text-white fs-2qx fw-bolder text-center mb-7'>                    
                    <span id="kt_landing_hero_text">Boost Your Brand Awareness</span><br/>            
                    <span id="kt_landing_hero_text">Anywhere, Anytime!</span>
                  </h1>
                  <h1 className=' text-white  mb-7' style={{fontSize: "56px"}}>                    
                    <span style={{background: "linear-gradient(to right, #FFD80C 0%, #12CE5D 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent"}}>
                      <span id="kt_landing_hero_text">30 Day Free Trial.</span>           
                    </span>
                  </h1>
                  <img
                    className='mx-auto w-375px w-md-100 w-xl-500px w-xxl-100 px-0 px-xxl-20  mb-10 mb-lg-20 rounded-2'
                    src={toAbsoluteUrl('/media/misc/auth-screens-02.png')}
                    alt=''
                  />
                </div>
              </div> */}

              {/* <div className='d-none d-md-inline d-lg-inline d-xl-inline text-white fs-base text-center pb-15 px-5 px-md-15'>
                    A leading provider of innovative
                    <span className='opacity-75-hover text-warning fw-bold'> digital signage solutions </span>,<br />
                    empowering businesses to 
                    <span className='opacity-75-hover text-warning fw-bold'> enhance their brand visibility </span>
                    and<br />
                    <span className='opacity-75-hover text-warning fw-bold'> engage with customers </span>
                    through 
                    <span className='opacity-75-hover text-warning fw-bold'> dynamic</span> and
                    <span className='opacity-75-hover text-warning fw-bold'> captivating visual experiences</span>
                    .<br />            
                  </div> */}

              {/* <div className="carousel-item">
                <div className="d-flex">
                    <div className="text-center col-4">
                        <div className="octagon mx-auto mb-5 d-flex w-200px h-200px bgi-no-repeat bgi-size-contain bgi-position-center" style={{backgroundImage: "url("+toAbsoluteUrl('/media/avatars/300-9.jpg')+")"}}></div>
                        <div className="mb-0">
                            <a href="#" className="text-dark fw-bold text-hover-primary fs-3">Carles Puyol</a>
                            <div className="text-muted fs-6 fw-semibold mt-1">QA Managers</div>
                        </div>
                    </div>
                </div>
              </div> */}
            {/* </div> */}

            <div className="d-flex align-items-center justify-content-center flex-wrap mt-5">
              <ol className="p-0 m-0 carousel-indicators carousel-indicators-dots">
                {runningAuthSlides.map((slide, ind) => {
                  return  <li data-bs-target="#kt_carousel_1_carousel"
                            key={`slide-dot-${ind}`}
                            data-bs-slide-to={ind}
                            className={`ms-1 ${ind === 0 ? "active":""}`}
                          ></li>
                })}                
              </ol>
            </div>
          </div>
          

          {/* begin::Title */}
          
          
          {/* end::Title */}

          
          
        </div>
        {/* end::Content */}
      </div>
      {/* end::Aside */}
    </div>
  )
}

export {AuthLayout}
